/* unplugin-vue-components disabled */import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadioButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio-button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "refund-search"
};
import InternalRefundOrder from './internalRefundOrder.vue';
import GlobalRefundOrder from './globalRefundOrder.vue';
import { disabledInternal } from '@/views/operate/hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const tabType = ref('internal');
    const isShowInternal = computed(() => {
      if (disabledInternal.includes(process.env.VUE_APP_PLAT)) {
        tabType.value = 'global';
        return false;
      }
      return true;
    });
    return (_ctx, _cache) => {
      const _component_el_radio_button = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_radio_group, {
        modelValue: _unref(tabType),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(tabType) ? tabType.value = $event : null)
      }, {
        default: _withCtx(() => [_unref(isShowInternal) ? (_openBlock(), _createBlock(_component_el_radio_button, {
          key: 0,
          label: "internal"
        }, {
          default: _withCtx(() => [_createTextVNode("国内")]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_radio_button, {
          label: "global"
        }, {
          default: _withCtx(() => [_createTextVNode("全球")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _unref(tabType) === 'internal' ? (_openBlock(), _createBlock(InternalRefundOrder, {
        key: 0
      })) : (_openBlock(), _createBlock(GlobalRefundOrder, {
        key: 1
      }))]);
    };
  }
});